import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('change', '.disclosure-form input[type=checkbox]', fn.handleFields)
    on('change', '.disclosure-form input[type=text]', fn.handleFields)
    on('keyup', '.disclosure-form input[type=text]', fn.handleFields)
    on('submit', '.disclosure-form', fn.handleSubmit)
  },

  handleFields: (e) => {
    const form = e.target.closest('form')
    const submit = form.querySelector('button[type=submit]')
    const checkbox = form.querySelector('input[type=checkbox]')
    const codeField = form.querySelector('input[name=code]')

    submit.disabled = !(checkbox.checked && codeField.value)
  },

  handleSubmit: (e) => {
    e.preventDefault()

    const form = e.target
    const error = form.querySelector('.disclosure-error')
    const submit = form.querySelector('button[type=submit]')

    error.style.display = 'none'

    ajax
      .url(form.action)
      .body(new FormData(form))
      .post()
      .json((res) => {
        if (res.success) {
          form.reset()
          submit.disabled = true
          window.open(res.url, '_blank')
        } else {
          error.style.display = 'block'
        }
      })
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-disclosurepage'),
  run: fn.init,
}
